import { getCookie, removeCookie } from "@workspace/cookies/browser";
import { useCallback } from "react";
import enableMarketingTag from "@/actions/enableMarketingTag";

type Args = {
  tag:
    | "freespins_acq_offer"
    | "acq_offer"
    | "reactoonz_FS"
    | "RiseofMerlin_FS"
    | "MoonPrinces_FS";
  cookie:
    | "freespinsAcqOffer"
    | "acq_offer"
    | "reactoonz_FS"
    | "RiseofMerlin_FS"
    | "MoonPrinces_FS";
  featureFlags: Map<string, boolean>;
};

const useSetMarketingTag = ({ tag, cookie, featureFlags }: Args) => {
  const shouldSetTag = useCallback(() => {
    const hasTag = featureFlags.get(tag as Feature);
    return !hasTag && getCookie(cookie);
  }, [cookie, featureFlags, tag]);

  const setTag = useCallback(async () => {
    if (!shouldSetTag()) {
      return;
    }
    const { isApplied } = await enableMarketingTag(tag);
    if (isApplied) {
      removeCookie(cookie);
    }
  }, [shouldSetTag, tag, cookie]);
  return [setTag];
};

export default useSetMarketingTag;
